import { useIdle } from 'react-use';

import { useSelectUserIdleDuration } from '../lib';

export const useIsIdle = () => {
  const idleTimeout = useSelectUserIdleDuration();
  return useIdle(idleTimeout);
};
